import { useAvailabilityTextContactService } from './hooks/useAvailabilityTextContactService';

const ContactService = ({ splitWeekend }: { splitWeekend?: boolean }) => {
  const text = useAvailabilityTextContactService({
    isPreSales: true,
    splitWeekend,
  });
  return text || null;
};

const ContactServiceWrapper = ({
  splitWeekend,
}: {
  splitWeekend?: boolean;
}) => (
  <ContactService
    data-testid="contact-service-info"
    splitWeekend={splitWeekend}
  />
);

ContactServiceWrapper.displayName = 'ContactServiceWrapper';

export default ContactServiceWrapper;
